import comp from "./CaptureImage";
export default comp;
